<template>
  <div class="formats">
    <ul>
      <li
        :style="`width: ${width(formatsCalculated.length)}%; flex-basis: ${width(formatsCalculated.length)}%;`"
        v-for="(format, index) in formatsCalculated"
        :key="index"
      >
        <Format :name="format.name" :slug="format.slug" :copy="format.copy" :link-text="format.linkText" />
      </li>
    </ul>
  </div>
</template>

<script>
import { pageMode } from './../../mixins/pageMode.js'
import Format from './Format.vue'

export default {
  name: 'FormatContainer',
  components: {
    Format,
  },
  data() {
    return {
      sets: {
        'never-settler': {
          '<50': ['fraction-pack'],
          '50-100': ['fraction-pack', 'select-brew', 'whole-bean'],
          '100-200': ['fraction-pack', 'select-brew', 'whole-bean'],
          '>200': ['fraction-pack', 'select-brew']
        },
        'economist': {
          '<50': ['filter-pack', 'fraction-pack'],
          '50-100': ['filter-pack', 'fraction-pack', 'select-brew'],
          '100-200': ['filter-pack', 'fraction-pack', 'select-brew'],
          '>200': ['select-brew']
        },
        'busy-bee': {
          '<50': ['filter-pack', 'fraction-pack'],
          '50-100': ['filter-pack', 'fraction-pack', 'select-brew'],
          '100-200': ['filter-pack', 'fraction-pack', 'select-brew'],
          '>200': ['fraction-pack', 'select-brew']
        }
      },
      formats: [
        {
          name: 'Filter Packs',
          slug: 'filter-pack',
          copy: `Ready-to-brew filter packs deliver ultimate convenience and consistency. This proprietary all-in-one product helps offices save time and eliminate coffee waste.`,
          linkText: 'View Filter Pack Recommendations >'
        },
        {
          name: 'Fraction Packs',
          slug: 'fraction-pack',
          copy: `Pre-measured fraction packs are ready to pour into the filter and brew. No measuring grounds or inconsistent strength&mdash;simply open, pour and enjoy!`,
          linkText: 'View Fraction Pack Recommendations >'
        },
        {
          name: 'On Demand',
          slug: 'select-brew',
          copy: `Make fresh, consistent cups of coffee available at the touch of a button! On-demand coffee is easy to use and opens up the possibility for specialty beverages.`,
          linkText: 'View On-Demand Recommendations >'
        },
        {
          name: 'Roast & Ground',
          slug: 'roast-ground',
          copy: `Let employees experience the beautiful color and rich aroma of our ground coffee as they brew it throughout your office.`,
          linkText: 'View Roast &amp; Ground Recommendations >'
        },
        {
          name: 'Whole Bean',
          slug: 'whole-bean',
          copy: `Craft the absolute freshest cups of coffee for employees and visitors when you grind whole Arabica coffee beans right before their eyes, and brew immediately into rich, delicious sips.`,
          linkText: 'View Whole Bean Recommendations >'
        }
      ],
    }
  },
  computed: {
    persona() {
      return this.$store.state.results.personaCalculated
    },
    employeeNumber() {
      return this.$store.state.quiz.number
    },
    formatsCalculated() {
      if (this.persona) {
        return this.formats.filter((r) => {
          // console.log('r', r.slug)
          // console.log('asdf', this.sets[this.persona].includes(r.slug))
          return this.sets[this.persona][this.employeeNumber].includes(r.slug)
        })
      } else {
        return this.formats
      }
    },
  },
  methods: {
    width(count) {
      return 100/count
    },
    // formatSelected(format) {
    //   this.$emit('formatSelected', format)
    // }
  },
  mixins: [pageMode]
}
</script>

<style lang="scss">

.formats {
  & > ul {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    background-color: white;
  }
  @include breakpoint(medium down) {
    & > ul {
      & > li {
        width: 100% !important;
        flex-basis: 100% !important;
        border-bottom: 1px solid $grayer;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  @include breakpoint(large) {
    & > ul {
      flex-flow: row nowrap;
      padding: 1em 0;
      & > li {
        border-left: 1px solid $grayer;
        &:first-child {
          border-left: none;
        }
      }
    }
  }
}

</style>